import React from "react";
import { CodeXml, Palette, TrendingUp, BrainCircuit, Headset, ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Intelligence & Geo-Marketing",
  description: "Individuiamo vuoti di mercato prima dei competitor incrociando dati demografici, flussi commerciali e potere d'acquisto reale.",
  icon: BrainCircuit,
  highlight: true,
  features: ["Analisi Predittiva", "Mappatura Flussi", "Data Mining Geopolitico", "Audit Competitor"]
}, {
  title: "Diplomazia & Matchmaking B2B",
  description: "Connessione diretta, traduzione nativa e negoziazione con i Big Buyer e i distributori certificati dell'area CSI.",
  icon: Palette,
  highlight: false
}, {
  title: "Logistica End-to-End",
  description: "Corridoi di esportazione blindati. Rete globale di hub proprietari per scortare il prodotto fino al magazzino finale.",
  icon: CodeXml,
  highlight: false
}, {
  title: "Analisi Geopolitica",
  description: "Monitoraggio costante dei quadri normativi e delle sanzioni per garantire la continuità operativa in mercati complessi.",
  icon: TrendingUp,
  highlight: false
}, {
  title: "Hub Strategici",
  description: "Accesso privilegiato a infrastrutture di stoccaggio sicure nei nodi nevralgici della nuova Via della Seta.",
  icon: Headset,
  highlight: false
}];
export default function SoluzioniSuMisura() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="24064" id="pilastri-operativi" className="relative w-full py-24 bg-background overflow-hidden dark bg-[#050505] text-white" ref={ref}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-3xl opacity-20" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl opacity-10" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,transparent_0%,#050505_100%)] z-10" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(220,20,60,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(220,20,60,0.05)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20" />
      </div>

      <div className="container relative z-20 mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tighter text-white uppercase mb-6">
            L'Infrastruttura <span className="text-primary">Invisibile</span>
          </h2>
          <p className="text-lg font-sans text-white/70 leading-relaxed">
            Ingegnerizziamo la penetrazione commerciale, blindiamo la logistica e ti sediamo ai tavoli dei grandi distributori in Russia, Kazakistan, Azerbaigian e CSI.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-fr">
          {services.map((service, index) => {
          const isTall = index === 0;
          const Icon = service.icon;
          return <div key={index} data-index={index} className={`
                  group relative rounded-none p-[1px] overflow-hidden transition-all duration-500
                  ${isTall ? "md:col-span-1 md:row-span-2" : "md:col-span-1"}
                  ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
                `} style={{
            transitionDelay: `${index * 100}ms`
          }}>
                {}
                <div className="absolute inset-[-100%] bg-[conic-gradient(from_90deg_at_50%_50%,#0000_0%,var(--color-primary)_50%,#0000_100%)] animate-[spin_6s_linear_infinite] opacity-0 group-hover:opacity-40 transition-opacity duration-700" />
                
                {}
                <div className="relative h-full w-full bg-[#111111]/40 backdrop-blur-xl rounded-none border border-white/10 p-8 flex flex-col overflow-hidden group-hover:border-primary/50 transition-colors duration-500">
                  {}
                  <Icon className="absolute -bottom-6 -right-6 w-48 h-48 text-primary/5 -rotate-12 pointer-events-none transition-transform duration-700 group-hover:scale-110 group-hover:text-primary/10" />
                  
                  {}
                  <div className="relative z-10 mb-6">
                    <div className="inline-flex items-center justify-center w-12 h-12 rounded-none bg-primary/10 text-primary mb-4 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                      <Icon className="w-6 h-6" />
                    </div>
                    <h3 className="text-2xl font-serif font-bold text-white group-hover:text-primary transition-colors duration-300">
                      {service.title}
                    </h3>
                  </div>

                  {}
                  <div className="relative z-10 flex-grow">
                    <p className="text-white/60 font-sans leading-relaxed mb-6">
                      {service.description}
                    </p>
                    
                    {}
                    {isTall && service.features && <ul className="space-y-3 mb-8">
                        {service.features.map((feature, i) => <li key={i} className="flex items-center gap-3 text-sm font-sans text-white/80">
                            <CircleCheck className="w-4 h-4 text-primary" />
                            {feature}
                          </li>)}
                      </ul>}
                  </div>

                  {}
                  <div className="relative z-10 mt-auto pt-4">
                    {isTall ? <Button asChild className="w-full md:w-auto rounded-none bg-primary hover:bg-primary/90 text-white font-sans font-bold">
                        <Link to="/HomePage">
                          Analisi Operativa <ArrowRight className="ml-2 w-4 h-4" />
                        </Link>
                      </Button> : <div className="h-[1px] w-12 bg-primary/40 group-hover:w-full group-hover:bg-primary transition-all duration-700" />}
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className={`mt-16 text-center ${isVisible ? "opacity-100" : "opacity-0"} transition-opacity duration-1000 delay-500`}>
          <p className="text-white/50 font-sans mb-6">Hai un asset strategico da internazionalizzare?</p>
          <Button asChild size="lg" variant="outline" className="rounded-none border-primary/40 text-white hover:bg-primary hover:text-white hover:border-primary font-sans font-bold transition-all duration-300">
            <Link to="/HomePage">
              Richiedi Valutazione di Accesso
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}